import React from 'react';

import {ErrorState} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {StyledContainer} from './styles';
import {BillsErrorStateProps} from './types';

const {error} = translations['pt-br'].privateFlow.myFinancial.openBills;

export function BillsErrorState({handleRefresh}: BillsErrorStateProps) {
	return (
		<StyledContainer>
			<ErrorState
				title={error.title}
				description={error.description}
				handleRefresh={handleRefresh}
			/>
		</StyledContainer>
	);
}
